export default {
  aiApi: {
    aiModels: {
      getAIModelTypes: '/api/aiModelApi/getAIModelTypes',
      getAIModelOptions: '/api/aiModelApi/getAIModelOptions',
      getModelConfigList: '/api/aiModelApi/getModelConfigList',
      saveOrUpdateConfig: '/api/aiModelApi/saveOrUpdateConfig',
      delConfig: '/api/aiModelApi/delConfig',
    },

    getChartAIMessages: 'api/IMAIServer/getChartAIMessages',
    sendAIMessage: 'api/IMAIServer/sendAIMessage',
    getChartAIStatus: 'api/IMAIServer/getChartAIStatus',
    clearAIToken: 'api/IMAIServer/clearAIToken',
    getAIBaseConfig: 'api/IMAIServer/getAIBaseConfig',
    getAIConfig: 'api/IMAIServer/getAIConfig',
    updateAIConfig: 'api/IMAIServer/updateAIConfig',
    // configQF: {
    //   getAIConfig: 'api/IMAIQFServer/getAIConfig',
    //   updateAIConfig: 'api/IMAIQFServer/updateAIConfig',
    //   getPromptList: 'api/IMAIQFServer/getPromptList',
    //   delPrompt: 'api/IMAIQFServer/delPrompt',
    //   saveOrUpdatePrompt: 'api/IMAIQFServer/saveOrUpdatePrompt',
    //   getPromptOptions: 'api/IMAIQFServer/getPromptOptions',
    //   getServiceOptions: 'api/IMAIQFServer/getServiceOptions',
    // },
    // configBST: {
    //   getAIConfig: 'api/IMAIBSTServer/getAIConfig',
    //   updateAIConfig: 'api/IMAIBSTServer/updateAIConfig',
    //   getServiceOptions: 'api/IMAIBSTServer/getServiceOptions'
    // },
    aiStatistics: {
      totalData: 'api/aiStatistics/totalData',
      exportData: 'api/aiStatistics/exportData',
    },
    aiTools: {
      applications: '/api/aiTools/applications',
      getLimitTypes: '/api/aiTools/getLimitTypes',
      saveOrUpdateApplication: '/api/aiTools/saveOrUpdateApplication',
      delApplications: '/api/aiTools/saveOrUpdateApplication',
      getAIAccessLogs: '/api/aiTools/getAIAccessLogs',
      getPromptList: '/api/aiTools/getPromptList',
      delPrompt: '/api/aiTools/delPrompt',
      saveOrUpdatePrompt: '/api/aiTools/saveOrUpdatePrompt',
      getAIToolsOptions: '/api/aiTools/getAIToolsOptions',
      changeStatus: '/api/aiTools/changeStatus',
      getToolUseLogs: '/api/aiToolCommon/getToolUseLogs',
      sendAIMessage: '/api/aiToolCommon/sendAIMessage',
      correctMessage: '/api/aiToolCommon/correctMessage',
      getAIToolStatus: '/api/aiToolCommon/getAIToolStatus',
      getAIToolPrompt: '/api/aiToolCommon/getAIToolPrompt',
      getUseTotal: '/api/aiToolCommon/getUseTotal',
      exportData: '/api/aiToolCommon/exportData',
    },
    aiLeader: {
      voiceInfo: '/api/ledgerAI/voiceInfo',
      ledgerPreFill: '/api/ledgerAI/ledgerPreFill'
    }
  }
}